/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PatientMedicationHistory } from './PatientMedicationHistory';
import {
    PatientMedicationHistoryFromJSON,
    PatientMedicationHistoryFromJSONTyped,
    PatientMedicationHistoryToJSON,
} from './PatientMedicationHistory';
import type { PatientMedicationValue } from './PatientMedicationValue';
import {
    PatientMedicationValueFromJSON,
    PatientMedicationValueFromJSONTyped,
    PatientMedicationValueToJSON,
} from './PatientMedicationValue';

/**
 * 
 * @export
 * @interface PatientMedication
 */
export interface PatientMedication {
    /**
     * 
     * @type {string}
     * @memberof PatientMedication
     */
    id?: string;
    /**
     * 
     * @type {PatientMedicationValue}
     * @memberof PatientMedication
     */
    value: PatientMedicationValue;
    /**
     * 
     * @type {Array<PatientMedicationHistory>}
     * @memberof PatientMedication
     */
    history?: Array<PatientMedicationHistory>;
}

/**
 * Check if a given object implements the PatientMedication interface.
 */
export function instanceOfPatientMedication(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "value" in value;

    return isInstance;
}

export function PatientMedicationFromJSON(json: any): PatientMedication {
    return PatientMedicationFromJSONTyped(json, false);
}

export function PatientMedicationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientMedication {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'value': PatientMedicationValueFromJSON(json['value']),
        'history': !exists(json, 'history') ? undefined : ((json['history'] as Array<any>).map(PatientMedicationHistoryFromJSON)),
    };
}

export function PatientMedicationToJSON(value?: PatientMedication | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'value': PatientMedicationValueToJSON(value.value),
        'history': value.history === undefined ? undefined : ((value.history as Array<any>).map(PatientMedicationHistoryToJSON)),
    };
}

